<template>
  <div class="cultureBreed cultureBreedContainer">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">种植品种设置</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box" v-if="(canEditAll = true)">
            <el-button size="small" type="info" plain @click="goSearch()" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd()" class="add" v-if="$store.state.curCompany.isQlwVersion == false && edit">增加</el-button>
          </div>
          <!-- 添加 -->
          <el-dialog :title="titleName" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" width="766px">
            <el-form :model="form" :rules="rules" ref="form" class="form">
              <el-form-item label="品种名称" prop="name" :label-width="formLabelWidth" style="margin-top: 15px">
                <el-col :span="14">
                  <el-input placeholder="请输入名称" v-model="form.name" clearable />
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" v-if="edit">
              <el-button @click="cancel('form')">取 消</el-button>
              <el-button type="primary" @click.native="save('form')">保 存</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="dataList" style="width: 100%" size="medium">
          <i slot="empty" style="font-style: normal">暂无数据</i>
          <el-table-column prop="name" label="品种名称" align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center">
            <template slot-scope="scope">
              <span @click="handleEdit(scope.$index, scope.row)" class="content-edit" v-if="edit">编辑</span>
              <span @click="handleDel(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import PageChange from "../../../common/PageChange";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "plantSpecies",
  mixins: [mixins],
  components: {
    PageChange,
  },
  data () {
    return {
      titleName: "",
      dialogFormVisible: false,
      form: {
        name: "", // 名称
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入品种名称",
            trigger: "blur",
          },
        ]
      },
      formLabelWidth: "140px",
      keyword: "", // 关键字
      dataList: [],
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
    };
  },

  computed: {

  },
  async mounted () {
    console.log(mixins, this.curCompany, 111);
    this.goSearch();
  },
  methods: {
    ...mapActions(modules.cultureBreed, [
      "getPlantSpeciesPage", //查询
      "deletePlantSpecies", //删除
      "addOrUpdatePlantSpecies", //添加/更新
    ]),

    //查询
    async goSearch (pageNum) {
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        KeyWord: this.keyword,
      };
      this.dataList = [];
      this.getPlantSpeciesPage(obj)
        .then((rsp) => {
          if (rsp && rsp.list) {
            this.pageInfo.totalPages = rsp.total;
            this.dataList = rsp.list;
          }else{
            this.pageInfo.totalPages = 0;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },

    //获取编辑数据
    async handleEdit (index, row) {
      this.titleName = "编辑种植品种信息";
      this.form = row;
      this.dialogFormVisible = true;
    },

    // 添加
    async goAdd (formName) {
      this.titleName = "添加养殖品种信息";
      this.form = {
        name: ""
      }
      this.dialogFormVisible = true;
    },
    closeDialog (formRule) {
      this.$refs[formRule].resetFields();
    },
    //取消
    cancel (formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      this.form = {
        name: ""
      }
    },
    //删除
    handleDel (index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deletePlantSpecies({ id: row.id });
          this.goSearch(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });

        });
    },
    //添加页---保存
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = this.form;
          this.addOrUpdatePlantSpecies(obj)
            .then((rsp) => {
              // this.setDialogFormVisibles(false);
              this.$message({
                message: "保存成功",
                type: "success",
              });

              this.form = {
                name: ""
              }
              this.dialogFormVisible = false;
              this.goSearch();
              this.$refs[formName].resetFields();
            })
            .catch((err) => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error",
              });

            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


  },
};
</script>

<style>
.cultureBreedContainer .el-form-item__error {
  padding-top: 0px;
  padding-left: 40px;
}
</style>
<style lang="stylus">
.el-tooltip__popper {
  line-height: 1.3;
  color: #fff;
  font-size: 14px;
  max-width: 300px;
}

.cultureBreed {
  .el-form {
    padding-left: 30px;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .choose-classify {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .el-dialog .el-form-item__content {
      bottom: -4px !important;
    }

    .el-form-item__content {
      margin-left: 18px;
    }
  }

  .el-form .el-form-item .el-form-item__label:before {
    left: -30px;
    color: #ff3817;
    font-size: 18px;
  }

  .el-dialog {
    border-radius: 6px;
    overflow: hidden;
    // height:440px;
    border-radius: 6px;

    .el-dialog__header {
      padding: 8px 20px 8px;
      border-radius: 6px 6px 0px 0px;
      background: linear-gradient(270deg, rgba(51, 137, 255, 1), rgba(31, 156, 244, 1), rgba(49, 170, 255, 1));

      .el-dialog__title {
        color: #fff;
      }
    }

    .el-form-item__content {
      line-height: 40px;
      position: relative;
      bottom: -5px;
      font-size: 16px;
    }

    .el-dialog__footer {
      text-align: left;
      position: relative;
      bottom: 12px;
      padding: 5px 205px 20px;
      // margin-bottom:20px;
    }

    .el-button--primary {
      margin-left: -10px;
      background: #3389ff;
    }

    .el-button .el-button--default {
      // margin-left:60px;
    }

    .el-button {
      width: 100px;
      height: 40px;
      margin-left: 24px;
    }

    .el-dialog__close {
      color: #fff;
    }

    .el-form .el-form-item .el-form-item__label {
      margin-top: 10px;
      margin-left: 40px;
      font-size: 16px;
    }

    .ruleForm {
      margin-left: 0px;
    }

    .el-select.unit .el-input__inner {
      width: 500px !important;
    }

    .el-select.fishType .el-input__inner {
      width: 210px !important;
    }

    .el-select.fishName .el-input__inner {
      width: 210px !important;
      margin-left: -35px;
    }
  }
}
</style>
